import { useQuery } from '@tanstack/vue-query';
import { AfClApi } from '@/Services/AfClApi';

export const useMediaKeys = () => useQuery({
    queryKey: ['media-keys'],
    queryFn: async () => await AfClApi.adminMediaKeys.getMediaKeys(),
    select: (response) => response.data.data
});
